import apiClient from './api';
import type {
  CompanyMember,
  ChangeRoleRequest,
  UserPublicInfo,
  PendingInvitation,
} from '../types/team';

export const teamService = {
  getMembers: async (companyId: number): Promise<CompanyMember[]> => {
    const response = await apiClient.get<CompanyMember[]>(`/companies/${companyId}/members`);
    return response.data;
  },

  getPendingInvitations: async (companyId: number): Promise<PendingInvitation[]> => {
    const response = await apiClient.get<PendingInvitation[]>(`/companies/${companyId}/members/invitations`);
    return response.data;
  },

  cancelInvitation: async (companyId: number, invitationId: number): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/members/invitations/${invitationId}`);
  },

  inviteByEmail: async (companyId: number, email: string): Promise<void> => {
    await apiClient.post(`/companies/${companyId}/members`, { email });
  },

  changeRole: async (companyId: number, userId: number, request: ChangeRoleRequest): Promise<CompanyMember> => {
    const response = await apiClient.put<CompanyMember>(`/companies/${companyId}/members/${userId}/role`, request);
    return response.data;
  },

  removeMember: async (companyId: number, userId: number): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/members/${userId}`);
  },

  getCurrentUser: async (): Promise<UserPublicInfo> => {
    const response = await apiClient.get<UserPublicInfo>('/users/me');
    return response.data;
  },
};
